import { Box } from '@mui/material'
import CalendarioAnual from '../components/CalendarioAnual'
import WidgetsCalendario from '../components/WidgetsCalendario'

import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import UserCard from 'common/components/UserCard'
import BotonSolicitudInterna from 'features/solicitudes/components/BotonSolicitudInterna'
import { selectVacaciones } from 'features/solicitudes/solicitudesSlice'
import i18n from 'lang/idiomas'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

/**
 * @module Calendario
 */

/**
 *
 * @param {Object} props
 * @param {string} [props.requestUser = null] -The user that will make the request
 * @param {string | Date} [props.fechasSolicitud] - The request date
 * @param {boolean} [props.requestUser] -
 */
const Calendario = ({
  vistaAmpliada = true,
  fechasSolicitud = [],
  requestUser = null,
  requestCode = null,
  requestOrigin = null,
}) => {
  const location = useLocation()
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear())
  const [user, setUser] = useState(requestUser ? requestUser : (location?.state?.user ?? null))
  const [userData, _] = useState({
    user: location?.state?.user ?? null,
    surname: location?.state?.surname ?? null,
    name: location?.state?.name ?? null,
    image: location?.state?.image ?? null,
  })
  const [display, setDisplay] = useState('D') // D: Dias, H: Horas

  const vacaciones = useSelector(selectVacaciones)

  const handleDisplayChange = (event) => {
    setDisplay(event.target.checked ? 'H' : 'D')
  }

  return (
    <Stack spacing={2}>
      {userData.user ? <UserCard datos={userData} /> : null}
      <WidgetsCalendario
        useUser={[user, setUser]}
        currentYear={currentYear}
        display={display}
        requestCode={requestCode}
        requestOrigin={requestOrigin}
      />
      {vistaAmpliada && !user ? (
        <>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 3 }}>
              {vacaciones.disfruta_horas === 'S' ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography variant="subtitle1">
                    {i18n.t('dias', { defaultValue: 'Días' })}
                  </Typography>
                  <Switch
                    onChange={handleDisplayChange}
                    value={display}
                    inputProps={{ 'aria-label': 'Switch horas' }}
                  />
                  <Typography variant="subtitle1">
                    {i18n.t('horas', { defaultValue: 'Horas' })}
                  </Typography>
                </Box>
              ) : (
                <></>
              )}
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <BotonSolicitudInterna
                titulo={i18n.t('solvach', { defaultValue: 'Solicitar Vacaciones por Horas' })}
                id_solicitud_pe="VAC03"
                buttonProps={{
                  sx: {
                    transition: '.3s',
                    textAlign: 'center',
                    width: {
                      xs: '100%',
                    },
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <BotonSolicitudInterna
                titulo={i18n.t('solvac', { defaultValue: 'Solicitar Vacaciones' })}
                id_solicitud_pe="VAC01"
                buttonProps={{
                  sx: {
                    transition: '.3s',
                    textAlign: 'center',
                    width: {
                      xs: '100%',
                    },
                  },
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <BotonSolicitudInterna
                titulo={i18n.t('solper', { defaultValue: 'Solicitar Permiso' })}
                id_solicitud_pe="SIT01"
                buttonProps={{
                  sx: {
                    transition: '.3s',
                    textAlign: 'center',
                    width: {
                      xs: '100%',
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
          <Box>
            <Divider sx={{ marginBottom: '2rem', marginTop: '2rem' }} />
          </Box>
          <CalendarioAnual
            useUser={[user, setUser]}
            currentYear={currentYear}
            setCurrentYear={setCurrentYear}
          />
        </>
      ) : (
        <>
          {vacaciones.disfruta_horas === 'S' ? (
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 3 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography variant="subtitle1">
                    {i18n.t('dias', { defaultValue: 'Días' })}
                  </Typography>
                  <Switch
                    onChange={handleDisplayChange}
                    value={display}
                    inputProps={{ 'aria-label': 'Switch horas' }}
                  />
                  <Typography variant="subtitle1">
                    {i18n.t('horas', { defaultValue: 'Horas' })}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
          <Divider sx={{ mt: 2, mb: 2 }} />
          {vacaciones.pendientes ? (
            <CalendarioAnual
              useUser={[user, setUser]}
              currentYear={currentYear}
              setCurrentYear={setCurrentYear}
              vacacionesPendientes={vacaciones.pendientes}
              vacacionesTipoDias={vacaciones.tipo_dias}
              allowSelection={true}
              fechasSolicitud={fechasSolicitud}
            />
          ) : null}
        </>
      )}
    </Stack>
  )
}

export default Calendario
